<section class="intro-container">
  <div class="logo-wrapper">
    <img class="logo" src="assets/icons/logo.svg" alt="Logo" class="logo" />
    <div class="text-mask">
      <span class="text">DABubble</span>
    </div>
  </div>
</section>
